import { showErrorNotification } from "components/notifications/events";
import { useCallback, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useLazyGetFortnoxAuthorizationUrlQuery } from "src/common/service/fusionHub/integrations/fortnoxApi";
import { URL_SYSTEM_IDENTIFIER } from "src/features/connector/addConnector/fortnox/constants";

export const useAuthorizationUrl = (companyDomainId: string) => {
	const [createLink, { isLoading: isCreatingUrl }] =
		useLazyGetFortnoxAuthorizationUrlQuery();

	const isProcessingRef = useRef(false);
	const { t } = useTranslation();

	return {
		isLoading: isCreatingUrl,
		onRequestAuthorizationUrl: useCallback(
			async (external?: boolean) => {
				if (isProcessingRef.current) {
					return;
				}

				let url: URL;
				if (external) {
					url = new URL("/fortnox-external-callback", location.origin);
				} else {
					url = new URL(location.pathname, location.origin);
					url.searchParams.set("system", URL_SYSTEM_IDENTIFIER);
				}

				const result = await createLink({
					companyDomainId,
					successRedirectUrl: url.toString(),
					errorRedirectUrl: url.toString(),
				});

				isProcessingRef.current = false;

				if ("error" in result) {
					showErrorNotification({
						message: t("Failed to initialize integration with Fortnox."),
					});
					return null;
				}
				return result.data!.authorizationUrl;
			},
			[createLink, companyDomainId],
		),
	};
};
